var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        title: "Cập nhật khối học",
        visible: _vm.dialogVisible,
        size: "sm",
        "panel-icon": "el-icon-edit",
        "panel-title": "Thông tin khối",
        "panel-subtitle": "Chỉnh sửa thông tin khối học",
        "confirm-loading": _vm.loadingButton,
        "confirm-disabled": !_vm.showSaveChange,
        "confirm-text": "Lưu",
        "confirm-type": "primary",
        "cancel-text": "Hủy",
        "cancel-type": "",
        "cancel-icon": "",
        "confirm-icon": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        "before-close": _vm.handleClose,
        cancel: _vm.handleClose,
        confirm: _vm.handleSave,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.editGrade,
            rules: _vm.formRules,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Tên khối học", prop: "gradeName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "Nhập tên khối" },
                model: {
                  value: _vm.editGrade.gradeName,
                  callback: function ($$v) {
                    _vm.$set(_vm.editGrade, "gradeName", $$v)
                  },
                  expression: "editGrade.gradeName",
                },
              }),
              _vm.customErrorMessages.newName
                ? _c(
                    "span",
                    { staticClass: "sk-note sk-note--danger sk-u-mt-12" },
                    [
                      _c("i", { staticClass: "el-icon-warning-outline" }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.customErrorMessages.newName)),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "sk-u-mt-12",
              attrs: { label: "Mô tả", prop: "gradeDescription" },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 1,
                  autosize: "",
                  placeholder: "Nhập mô tả",
                },
                model: {
                  value: _vm.editGrade.gradeDescription,
                  callback: function ($$v) {
                    _vm.$set(_vm.editGrade, "gradeDescription", $$v)
                  },
                  expression: "editGrade.gradeDescription",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }